import React, { useState, useMemo } from 'react';
import { Search, Type, AlignLeft, ExternalLink, Pin, Pause, Play } from 'lucide-react';
import AccountSwitcher from '../../../components/AccountSwitcher';

const ht = (text, pin) => (pin ? { text, pin } : text);
const getText = (h) => (typeof h === 'string' ? h : h.text);
const getPin = (h) => (typeof h === 'object' && h !== null ? h.pin : null);

const STRENGTH = {
  Excellent: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Good: 'bg-sky-50 text-sky-700 border-sky-200',
  Average: 'bg-amber-50 text-amber-700 border-amber-200',
  Poor: 'bg-red-50 text-red-700 border-red-200',
  Pending: 'bg-gray-100 text-gray-500 border-gray-200',
};

const AD_DATA = [
  {
    campaign: 'SRCH_BRND_Yenilio',
    label: 'Yenilio (Brand)',
    ads: [
      {
        adGroup: 'Brand',
        strength: 'Average',
        status: 'Enabled',
        headlines: [
          "iPhone Yenilio'da",
          ht('Yenilio', 1),
          '"Gürgençler deneyimi, güvencesi"',
          'Yenilio Yenisi Gülümsetio',
          "Yenilio'da %10 Havale İndirimi",
          "Yenilio'da Yenilenmiş iPhone",
          "iPhone'da 12 Ay Garanti",
          "Yenilio'da iPhone Sahibi Ol",
          "iPhone'da 12 Ay Taksit İmkanı",
          '12 Ay TSE Garantisi',
          "Apple Kalitesi Yenilio'da",
          'TSE Sertifikalı Garanti',
          'Apple Yetkili Yenileme Merkezi',
          'Akıllı Seçim Yenilenmiş iPhone',
          "21 Gün iade hakkı Yenilio'da",
        ],
        descriptions: [
          "Yenilio Yenisi Apple ürünlerinde 21 gün iade hakkı ve peşin fiyatına 12 ay taksit",
          'Ticaret bakanlığı onaylı yenileme merkezi Yenilio. Gürgençler deneyimi ve güvencesiyle.',
          'Peşin fiyatına 12 ay taksitle hemen şimdi bir Apple ürününe sahip ol.',
          "Apple Yetkili Yenileme Merkezi Yenilio'da iPhone, Mac, Watch ve iPad modellerine sahip ol.",
        ],
        path: 'yenilio / yenisi',
        url: 'https://www.yenilio.com/',
      },
      {
        adGroup: 'Brand (v2)',
        strength: 'Pending',
        status: 'Paused',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio yenisi gülümsetio',
          'Yenilio ile iPhone Fırsatları', "Yenilenmiş iPhone Yenilio'da",
          'Ücretsiz Kargo', 'Yenilenmiş Apple Ürünleri',
          "iPhone'da 12 ay garanti", "iPhone Yenilio'da",
          "iPhone'da 6 ay taksit imkanı", "iPhone'da 12 ay taksit imkanı",
          'Vade Farksız Taksit Fırsatı', '12 Ay Yenilio Garantisi',
          "Yenilio Yenisi iPhone'lar",
        ],
        descriptions: [
          ht('Vade Farksız 12 Ay Taksit, Lansmana Özel %10 İndirim, Öğrenci / Öğretmenlere ek %3 İndirim', 1),
          "iPhone Ürünlerinde Üniversite Öğrencilerine Ek %3 İndirim Fırsatı Yenilio'da",
          "Yenilio olarak, yenilenmiş iPhone'ları TSE standartlarına uygun şekilde size sunuyoruz.",
          "Yenilenmiş iPhone'da Vade Farksız 12 Taksite Varan Ödeme Seçeneği Yenilio'da",
        ],
        path: 'yenilio',
        url: 'https://www.yenilio.com/',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPhone_11',
    label: 'iPhone 11',
    ads: [
      {
        adGroup: 'iPhone_11',
        strength: 'Pending',
        status: 'Enabled',
        headlines: [
          'iPhone 11', 'Vade Farksız 12 Ay Taksit', 'Ekstra %10 Havale İndirimi',
          'Yenilio Yenisi', 'Yenilio Yenisi iPhone 11', '12 Ay TSE Garantili iPhone 11',
          '%10 İndirim Faizsiz 12 Taksit', 'Yenilio Yenisi Gülümsetio',
          '12 Ay Taksit İmkanı', 'Taksitli iPhone 11 Sahibi Ol',
          '1649 TL Taksitle iPhone 11 Al', 'Peşin Fiyatına 12 Ay Taksit',
          'Gürgençler Güvencesiyle',
        ],
        descriptions: [
          'Vade Farksız 12 Ay Taksit İmkanı, Yenilio Yenisi Apple Ürünleri',
          '12 Ay TSE Sertifikalı Garanti, Ek %10 Havale İndirimi, 15 Gün İade Hakkı, 1000TL Worldpuan',
          "Yenilio Yenisi 27 Nokta Kontrolü, Ücretsiz Kargo, World'e Özel 12 Taksit",
          'Yenilio Yenisi 12 Ay Taksit Fırsatıyla Gülümsetio',
        ],
        path: 'yenilio / iphone-11',
        url: 'https://www.yenilio.com/iphone/iphone-11',
      },
      {
        adGroup: 'iPhone_11 (v2)',
        strength: 'Pending',
        status: 'Paused',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio yenisi gülümsetio',
          'Yenilio ile iPhone Fırsatları', "Yenilenmiş iPhone Yenilio'da",
          'Ücretsiz Kargo', 'Yenilenmiş Apple Ürünleri',
          'Yenilio yenisi iPhone 11', "iPhone 11 Yenilio'da",
          "iPhone'da 6 ay taksit imkanı", "iPhone'da 12 ay taksit imkanı",
          'Vade Farksız Taksit Fırsatı', '12 Ay Yenilio Garantisi',
          "Yenilio Yenisi iPhone'lar", 'TSE Standartlarına Uygun',
        ],
        descriptions: [
          ht('Vade Farksız 12 Ay Taksit, Lansmana Özel %10 İndirim, Öğrenci / Öğretmenlere ek %3 İndirim', 1),
          "Yenilenmiş iPhone 11 Lansmana Özel %10 indirim ile Yenilio'da",
          "Yenilio olarak, yenilenmiş iPhonele'ları TSE standartlarına uygun olarak size sunuyoruz.",
          "Yenilenmiş iPhone'da Vade Farksız 12 Taksite Varan Ödeme Seçeneği Yenilio'da",
        ],
        path: 'yenilio',
        url: 'https://www.yenilio.com/iphone/iphone-11',
      },
      {
        adGroup: 'iPhone_11_pro',
        strength: 'Pending',
        status: 'Enabled',
        headlines: [
          'Yenilio', 'Vade Farksız 12 Ay Taksit', 'Yenilio Yenisi Gülümsetio',
          "%10 Havale İndirimi Yenilio'da", "Yenilenmiş iPhone Yenilio'da",
          'TSE Sertifikalı Garanti', '12 Ay Taksit Fırsatı',
          'Yenilio yenisi iPhone 11 Pro', "iPhone 11 Pro Yenilio'da",
          "iPhone'da 6 ay taksit imkanı", "iPhone'da 12 Ay Taksit İmkanı",
          '12 Ay Yenilio Garantisi', 'Peşin Fiyatına 12 Ay Taksit',
        ],
        descriptions: [
          'Vade Farksız 12 Ay Taksit İmkanı, Yenilio Yenisi Apple Ürünleri',
          '12 Ay TSE Sertifikalı Garanti, Ek %10 Havale İndirimi, 21 Gün İade Hakkı',
          'Yenilio Yenisi 27 Nokta Kontrolü, Ücretsiz Kargo',
          'Yenilio Yenisi iPhone Sahibi Olma Fırsatını Kaçırma',
        ],
        path: 'yenilio / iphone-11',
        url: 'https://www.yenilio.com/iphone/iphone-11?filters[categories]=925',
      },
      {
        adGroup: 'iPhone_11_pro (v2)',
        strength: 'Pending',
        status: 'Paused',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio yenisi gülümsetio',
          'Yenilio ile iPhone Fırsatları', "Yenilenmiş iPhone Yenilio'da",
          'Ücretsiz Kargo', 'Yenilenmiş Apple Ürünleri',
          'Yenilio yenisi iPhone 11 Pro', "iPhone 11 Pro Yenilio'da",
          "iPhone'da 6 ay taksit imkanı", "iPhone'da 12 ay taksit imkanı",
          'Vade Farksız Taksit Fırsatı', '12 Ay Yenilio Garantisi',
          "Yenilio Yenisi iPhone'lar", 'TSE Standartlarına Uygun',
        ],
        descriptions: [
          ht('Vade Farksız 12 Ay Taksit, Lansmana Özel %10 İndirim, Öğrenci / Öğretmenlere ek %3 İndirim', 1),
          "Yenilenmiş iPhone ürünlerini en uygun fiyatlarla Yenilio'da keşfedin.",
          "Yenilio olarak, yenilenmiş iPhonele'ları TSE standartlarına uygun olarak size sunuyoruz.",
          "Yenilenmiş iPhone'da Vade Farksız 12 Taksite Varan Ödeme Seçeneği Yenilio'da",
        ],
        path: 'yenilio',
        url: 'https://www.yenilio.com/iphone/iphone-11?filters[categories]=925',
      },
      {
        adGroup: 'iPhone_11 pro_max',
        strength: 'Pending',
        status: 'Enabled',
        headlines: [
          'Yenilio', 'Vade Farksız 12 Ay Taksit', 'Yenilio Yenisi Gülümsetio',
          "%10 Havale İndirimi Yenilio'da", "Yenilenmiş iPhone Yenilio'da",
          'Aksesuarda %50 İndirim', '12 Ay Taksit Fırsatı',
          'Yenilio iPhone 11 Pro Max', "iPhone 11 Pro Max Yenilio'da",
          "iPhone'da 6 ay taksit imkanı", "iPhone'da 12 Ay Taksit İmkanı",
          '12 Ay Yenilio Garantisi', 'Peşin Fiyatına 12 Ay Taksit',
          'TSE Sertifikalı Garanti',
        ],
        descriptions: [
          'Vade Farksız 12 Ay Taksit İmkanı, Yenilio Yenisi Apple Ürünleri',
          '12 Ay TSE Sertifikalı Garanti, Ek %10 Havale İndirimi, 15 Gün İade Hakkı, 1000TL WorldPuan',
          "Yenilio Yenisi 27 Nokta Kontrolü, Ücretsiz Kargo, World'e Özel 12 Taksit",
          '12 Ay Taksit İmkanıyla Yenilio Yenisi iPhone Sahibi Olma Fırsatını Kaçırma',
        ],
        path: 'yenilio / iphone-11',
        url: 'https://www.yenilio.com/iphone/iphone-11?filters[categories]=928',
      },
      {
        adGroup: 'iPhone_11 pro_max (v2)',
        strength: 'Pending',
        status: 'Paused',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio yenisi gülümsetio',
          'Yenilio ile iPhone Fırsatları', "Yenilenmiş iPhone Yenilio'da",
          'Ücretsiz Kargo', 'Yenilenmiş Apple Ürünleri',
          'Yenilio iPhone 11 Pro Max', "iPhone 11 Pro Max Yenilio'da",
          "iPhone'da 6 ay taksit imkanı", "iPhone'da 12 ay taksit imkanı",
          'Vade Farksız Taksit Fırsatı', '12 Ay Yenilio Garantisi',
          "Yenilio Yenisi iPhone'lar", 'TSE Standartlarına Uygun',
        ],
        descriptions: [
          ht('Vade Farksız 12 Ay Taksit, Lansmana Özel %10 İndirim, Öğrenci / Öğretmenlere ek %3 İndirim', 1),
          "Yenilenmiş iPhone ürünlerini en uygun fiyatlarla Yenilio'da keşfedin.",
          "Yenilio olarak, yenilenmiş iPhonele'ları TSE standartlarına uygun olarak size sunuyoruz.",
          "Yenilenmiş iPhone'da Vade Farksız 12 Taksite Varan Ödeme Seçeneği Yenilio'da",
        ],
        path: 'yenilio',
        url: 'https://www.yenilio.com/iphone/iphone-11?filters[categories]=928',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPhone_13',
    label: 'iPhone 13',
    ads: [
      {
        adGroup: 'iPhone_13',
        strength: 'Pending',
        status: 'Enabled',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio Yenisi Gülümsetio',
          "%10 Havale İndirimi Yenilio'da", "Yenilenmiş iPhone Yenilio'da",
          'Yenilio Yenisi iPhone 13', "iPhone 13 Yenilio'da",
          'Peşin Fiyatına 12 Ay Taksit', '12 Ay Yenilio Garantisi',
          'TSE Sertifikalı Garanti', 'A Kalite Yenilio Yenisi',
          'Vade Farksız 12 Ay Taksit',
        ],
        descriptions: [
          'Yenilio Yenisi Apple Ürünleri',
          'Yenilio Yenisi iPhone 13 Modellerinde Peşin Fiyatına 12 Ay Taksit',
        ],
        path: 'yenilio / iphone-13',
        url: 'https://www.yenilio.com/iphone/iphone-13?filters[categories]=943',
      },
      {
        adGroup: 'iPhone_13 (v2)',
        strength: 'Pending',
        status: 'Paused',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio yenisi gülümsetio',
          'Yenilio ile iPhone Fırsatları', "Yenilenmiş iPhone Yenilio'da",
          'Ücretsiz Kargo', 'Yenilenmiş Apple Ürünleri',
          'Yenilio yenisi iPhone 13', "iPhone 13 Yenilio'da",
          "iPhone'da 6 ay taksit imkanı", "iPhone'da 12 ay taksit imkanı",
          'Vade Farksız Taksit Fırsatı', '12 Ay Yenilio Garantisi',
          "Yenilio Yenisi iPhone'lar", 'TSE Standartlarına Uygun',
        ],
        descriptions: [
          ht('Vade Farksız 12 Ay Taksit, Lansmana Özel %10 İndirim, Öğrenci / Öğretmenlere ek %3 İndirim', 1),
          "iPhone Ürünlerinde Üniversite Öğrencilerine Ek %3 İndirim Fırsatı Yenilio'da",
          "Yenilio olarak, yenilenmiş iPhonele'ları TSE standartlarına uygun olarak size sunuyoruz.",
          "Yenilenmiş iPhone'da Vade Farksız 12 Taksite Varan Ödeme Seçeneği Yenilio'da",
        ],
        path: 'yenilio',
        url: 'https://www.yenilio.com/iphone/iphone-13',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPhone_14',
    label: 'iPhone 14',
    ads: [
      {
        adGroup: 'iPhone_14',
        strength: 'Pending',
        status: 'Enabled',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio Yenisi gülümsetio',
          'Yenilio ile iPhone Fırsatları', "Yenilenmiş iPhone Yenilio'da",
          'Ücretsiz Kargo', 'Yenilenmiş Apple Ürünleri',
          'Yenilio Yenisi iPhone 14', "iPhone 14 Yenilio'da",
          'Yenilenmiş iPhone 14', "iPhone'da 12 Ay Taksit İmkanı",
          '12 Ay Yenilio Garantisi', "Yenilio Yenisi iPhone'lar",
          'TSE Standartlarına Uygun', 'Peşin Fiyatına 12 Ay Taksit',
        ],
        descriptions: [
          'Yenilio Yenisi Apple Ürünleri',
          'Yenilio Yenisi iPhone 14 Modellerinde Peşin Fiyatına 12 Ay Taksit',
        ],
        url: 'https://www.yenilio.com/iphone/iphone-14?filters[quantity_and_stock_status]=yes&filters[categories]=955',
      },
      {
        adGroup: 'iPhone_14_pro',
        strength: 'Pending',
        status: 'Enabled',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio Yenisi gülümsetio',
          'Yenilio ile iPhone Fırsatları', "Yenilenmiş iPhone Yenilio'da",
          'Ücretsiz Kargo', 'Yenilenmiş Apple Ürünleri',
          'Yenilio Yenisi iPhone 14 Pro', "iPhone 14 Pro Yenilio'da",
          'Yenilenmiş iPhone 14 Pro', "iPhone'da 12 ay taksit imkanı",
          '12 Ay Yenilio Garantisi', "Yenilio Yenisi iPhone'lar",
          'TSE Standartlarına Uygun', 'Peşin Fiyatına 12 Ay Taksit',
        ],
        descriptions: [
          'Yenilio Yenisi Apple Ürünleri',
          'Yenilio Yenisi iPhone 14 Pro Modellerinde Peşin Fiyatına 12 Ay Taksit',
        ],
        url: 'https://www.yenilio.com/iphone/iphone-14?filters[quantity_and_stock_status]=yes&filters[categories]=961',
      },
      {
        adGroup: 'iPhone_14_pro_max',
        strength: 'Pending',
        status: 'Paused',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio yenisi gülümsetio',
          'Yenilio ile iPhone Fırsatları', "Yenilenmiş iPhone Yenilio'da",
          'Ücretsiz Kargo', 'Yenilenmiş Apple Ürünleri',
          "iPhone 14 Pro Max Yenilio'da", "iPhone'da 6 ay taksit imkanı",
          ht("iPhone'da 12 ay taksit imkanı", 2),
          '12 Ay Yenilio Garantisi', "Yenilio Yenisi iPhone'lar",
          'TSE Standartlarına Uygun', 'Peşin fiyatına 12 ay taksit',
        ],
        descriptions: [
          'Vade Farksız 12 Ay Taksit İmkanı, Öğrenci & Öğretmenlere Ek %3 İndirim',
          "iPhone Ürünlerinde Üniversite Öğrencilerine Ek %3 İndirim Fırsatı Yenilio'da",
          "Yenilio olarak, yenilenmiş iPhonele'ları TSE standartlarına uygun olarak size sunuyoruz.",
          "Yenilenmiş iPhone'da Vade Farksız 12 Taksite Varan Ödeme Seçeneği Yenilio'da",
        ],
        path: 'yenilio',
        url: 'https://www.yenilio.com/iphone/iphone-14-pro?filters[categories]=964',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPhone_15',
    label: 'iPhone 15',
    ads: [
      {
        adGroup: 'iPhone_15',
        strength: 'Pending',
        status: 'Enabled',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio Yenisi gülümsetio',
          'Yenilio ile iPhone Fırsatları', "Yenilenmiş iPhone Yenilio'da",
          ht('Peşin Fiyatına 12 Ay Taksit', 2), 'Yenilenmiş Apple Ürünleri',
          'Yenilio Yenisi iPhone 15', "iPhone 15 Yenilio'da",
          'Yenilenmiş iPhone 15', "iPhone'da 12 Ay Taksit İmkanı",
          '12 Ay Yenilio Garantisi', "Yenilio Yenisi iPhone'lar",
          'TSE Standartlarına Uygun', 'Vade Farksız 12 Ay Taksit',
        ],
        descriptions: [
          'Yenilio Yenisi Apple Ürünleri',
          'Yenilio Yenisi iPhone 15 Modellerinde Peşin Fiyatına 12 Ay Taksit',
        ],
        path: 'yenilenmiş / iPhone15',
        url: 'https://www.yenilio.com/iphone/iphone-15',
      },
      {
        adGroup: 'iPhone_15_pro',
        strength: 'Pending',
        status: 'Enabled',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio Yenisi gülümsetio',
          'Yenilio ile iPhone Fırsatları', "Yenilenmiş iPhone Yenilio'da",
          'Ücretsiz Kargo', 'Yenilenmiş Apple Ürünleri',
          'Yenilio Yenisi iPhone 15 Pro', "iPhone 15 Pro Yenilio'da",
          'Yenilenmiş iPhone 15 Pro', "iPhone'da 12 ay taksit imkanı",
          '12 Ay Yenilio Garantisi', "Yenilio Yenisi iPhone'lar",
          'TSE Standartlarına Uygun', 'Peşin Fiyatına 12 Ay Taksit',
        ],
        descriptions: [
          'Yenilio Yenisi Apple Ürünleri',
          'Yenilio Yenisi iPhone 15 Pro Modellerinde Peşin Fiyatına 12 Ay Taksit',
        ],
        path: 'yenilenmiş / iPhone15',
        url: 'https://www.yenilio.com/iphone/iphone-16/iphone-16-pro',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_COMP',
    label: 'Rakip Markalar',
    ads: [
      {
        adGroup: 'Comp_getmobil',
        strength: 'Pending',
        status: 'Enabled',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio Yenisi Gülümsetio',
          "%10 Havale İndirimi Yenilio'da", "Yenilenmiş iPhone Yenilio'da",
          'TSE Sertifikalı Garanti',
          ht('Vade Farksız 12 Ay Taksit', 2),
          "Yenilio Yenisi iPhone'lar", 'Yenilio Yenisi iPhone Ürünleri',
          "iPhone'da 6 ay taksit imkanı", "iPhone'da 12 Ay Taksit İmkanı",
          '12 Ay Yenilio Garantisi', 'Gürgençler Güvencesi ile',
        ],
        descriptions: [
          'Vade Farksız 12 Ay Taksit İmkanı, Yenilio Yenisi Apple Ürünleri',
          '12 Ay TSE Sertifikalı Garanti, Ek %10 Havale İndirimi, 21 Gün İade Hakkı',
          'Yenilio Yenisi 27 Nokta Kontrolü, Ücretsiz Kargo',
          '12 Ay Taksit İmkanıyla Yenilio Yenisi iPhone Sahibi Olma Fırsatını Kaçırma',
        ],
        path: 'yenilio / iphone',
        url: 'https://www.yenilio.com/',
      },
      {
        adGroup: 'Comp_getmobil (v2)',
        strength: 'Poor',
        status: 'Paused',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio Yenisi Gülümsetio',
          "%10 Havale İndirimi Yenilio'da", "Yenilenmiş iPhone Yenilio'da",
          'Aksesuarda %50 İndirim', 'Vade Farksız 12 Ay Taksit',
          "Yenilio Yenisi iPhone'lar", 'Yenilio Yenisi iPhone Ürünleri',
          "iPhone'da 6 ay taksit imkanı",
          ht('Peşin Fiyatına 12 Ay Taksit', 2),
          '12 Ay Yenilio Garantisi', 'TSE Sertifikalı Garanti',
        ],
        descriptions: [
          'Vade Farksız 12 Ay Taksit İmkanı, Yenilio Yenisi Apple Ürünleri',
          '12 Ay TSE Sertifikalı Garanti, Ek %10 Havale İndirimi, 21 Gün İade Hakkı, 1000TL WorldPuan',
          '12 Ay Taksit İmkanıyla Yenilio Yenisi iPhone Sahibi Olma Fırsatını Kaçırma',
        ],
        path: 'yenilio / iphone',
        url: 'https://www.yenilio.com/',
      },
      {
        adGroup: 'Comp_getmobil (v3)',
        strength: 'Pending',
        status: 'Paused',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio yenisi gülümsetio',
          'Yenilio ile iPhone Fırsatları', 'Yenilenmiş iPhone Yenilio',
          'Ücretsiz Kargo', 'Yenilenmiş Apple Ürünleri',
          "Yenilenmiş iPhone Yenilio'da", 'Yenilio Yenisi iPhone Ürünleri',
          "iPhone'da 6 ay taksit imkanı", "iPhone'da 12 ay taksit imkanı",
          'Vade Farksız Taksit Fırsatı', '12 Ay Yenilio Garantisi',
          "Yenilio Yenisi iPhone'lar", 'TSE Standartlarına Uygun',
        ],
        descriptions: [
          ht('Vade Farksız 12 Ay Taksit, Lansmana Özel %10 İndirim, Öğrenci / Öğretmenlere ek %3 İndirim', 1),
          "Yenilenmiş iPhone ürünlerini en uygun fiyatlarla Yenilio'da keşfedin.",
          "Yenilio olarak, yenilenmiş iPhonele'ları TSE standartlarına uygun olarak size sunuyoruz.",
          "Yenilenmiş iPhone'da Vade Farksız 12 Taksite Varan Ödeme Seçeneği Yenilio'da",
        ],
        path: 'yenilio',
        url: 'https://www.yenilio.com/',
      },
      {
        adGroup: 'Comp_getmobile',
        strength: 'Pending',
        status: 'Enabled',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio Yenisi Gülümsetio',
          "%10 Havale İndirimi Yenilio'da", "Yenilenmiş iPhone Yenilio'da",
          ht('Vade Farksız 12 Ay Taksit', 2),
          "Yenilio Yenisi iPhone'lar", 'Yenilio Yenisi iPhone Ürünleri',
          "iPhone'da 6 ay taksit imkanı", "iPhone'da 12 Ay Taksit İmkanı",
          '12 Ay Yenilio Garantisi', 'Gürgençler Güvencesi ile',
          'TSE Sertifikalı Garanti',
        ],
        descriptions: [
          'Vade Farksız 12 Ay Taksit İmkanı, Yenilio Yenisi Apple Ürünleri',
          '12 Ay TSE Sertifikalı Garanti, Ek %10 Havale İndirimi, 21 Gün İade Hakkı',
          'Yenilio Yenisi 27 Nokta Kontrolü, Ücretsiz Kargo',
          '12 Ay Taksit İmkanıyla Yenilio Yenisi iPhone Sahibi Olma Fırsatını Kaçırma',
        ],
        path: 'yenilio / iphone',
        url: 'https://www.yenilio.com/',
      },
      {
        adGroup: 'Comp_getmobile (v2)',
        strength: 'Pending',
        status: 'Paused',
        headlines: [
          'Yenilio', 'yenilio.com', 'Yenilio yenisi gülümsetio',
          'Yenilio ile iPhone Fırsatları', 'Yenilenmiş iPhone Yenilio',
          'Ücretsiz Kargo', 'Yenilenmiş Apple Ürünleri',
          "Yenilenmiş iPhone Yenilio'da", 'Yenilio Yenisi iPhone Ürünleri',
          "iPhone'da 6 ay taksit imkanı", "iPhone'da 12 ay taksit imkanı",
          'Vade Farksız Taksit Fırsatı', '12 Ay Yenilio Garantisi',
          "Yenilio Yenisi iPhone'lar", 'TSE Standartlarına Uygun',
        ],
        descriptions: [
          ht('Vade Farksız 12 Ay Taksit, Lansmana Özel %10 İndirim, Öğrenci / Öğretmenlere ek %3 İndirim', 1),
          "Yenilenmiş iPhone ürünlerini en uygun fiyatlarla Yenilio'da keşfedin.",
          "Yenilio olarak, yenilenmiş iPhonele'ları TSE standartlarına uygun olarak size sunuyoruz.",
          "Yenilenmiş iPhone'da Vade Farksız 12 Taksite Varan Ödeme Seçeneği Yenilio'da",
        ],
        path: 'yenilio',
        url: 'https://www.yenilio.com/',
      },
    ],
  },
  {
    campaign: 'SRCH_GNRC_Macbook',
    label: 'MacBook',
    ads: [
      {
        adGroup: 'Macbook Pro - Yenilenmis',
        strength: 'Poor',
        status: 'Enabled',
        headlines: [
          'Yenilio', 'Peşin Fiyatına 12 Ay Taksit', 'Macbook Pro',
          'Yenilenmiş Macbook Pro', 'Yenilio Yenisi Macbook Pro',
          'TSE Standartlarına Uygun', '12 Ay Garanti',
          'Yenilio Yenisi Gülümsetio', 'Şimdi Keşfet',
          'Havaleye Ek %10 İndirim',
        ],
        descriptions: [
          'Yenilio Yenisi Apple Ürünleri',
          'Yenilio Yenisi MacBook Pro Modellerinde Peşin Fiyatına 12 Ay Taksit',
        ],
        url: 'https://www.yenilio.com/mac/macbook-pro?filters[quantity_and_stock_status]=yes',
      },
      {
        adGroup: 'Macbook Air - Yenilenmis',
        strength: 'Poor',
        status: 'Enabled',
        headlines: [
          'Yenilio', 'Peşin Fiyatına 12 Ay Taksit', 'Macbook Air',
          'Yenilenmiş Macbook Air', 'Yenilio Yenisi Macbook Air',
          'TSE Standartlarına Uygun', '12 Ay Garanti',
          'Yenilio Yenisi Gülümsetio', 'Şimdi Keşfet',
          'Havaleye Ek %10 İndirim',
        ],
        descriptions: [
          'Yenilio Yenisi Apple Ürünleri',
          'Yenilio Yenisi MacBook Air Modellerinde Peşin Fiyatına 12 Ay Taksit',
        ],
        url: 'https://www.yenilio.com/mac/macbook-air?filters[quantity_and_stock_status]=yes',
      },
      {
        adGroup: 'Yenilenmis (Genel)',
        strength: 'Poor',
        status: 'Enabled',
        headlines: [
          'Yenilio', 'Peşin Fiyatına 12 Ay Taksit', 'Macbook',
          'Yenilenmiş Macbook', 'Yenilio Yenisi Macbook',
          'TSE Standartlarına Uygun', '12 Ay Garanti',
          'Yenilio Yenisi Gülümsetio', 'Şimdi Keşfet',
          'Havaleye Ek %10 İndirim',
        ],
        descriptions: [
          'Yenilio Yenisi Apple Ürünleri',
          'Yenilio Yenisi Macbook Modellerinde Peşin Fiyatına 12 Ay Taksit',
        ],
        url: 'https://www.yenilio.com/mac?filters[quantity_and_stock_status]=yes',
      },
    ],
  },
];

export default function AdCopyReportYenilio() {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredData = useMemo(() => {
    const q = searchQuery.toLowerCase().trim();
    if (!q) return AD_DATA;
    return AD_DATA.map(c => ({
      ...c,
      ads: c.ads.filter(ad =>
        ad.headlines.some(h => getText(h).toLowerCase().includes(q)) ||
        ad.descriptions.some(d => (typeof d === 'string' ? d : d.text).toLowerCase().includes(q)) ||
        c.label.toLowerCase().includes(q) ||
        ad.adGroup.toLowerCase().includes(q)
      ),
    })).filter(c => c.ads.length > 0);
  }, [searchQuery]);

  const filteredAds = useMemo(() => filteredData.reduce((s, c) => s + c.ads.length, 0), [filteredData]);
  const enabledAds = useMemo(() => filteredData.reduce((s, c) => s + c.ads.filter(a => a.status === 'Enabled').length, 0), [filteredData]);
  const pausedAds = useMemo(() => filteredData.reduce((s, c) => s + c.ads.filter(a => a.status === 'Paused').length, 0), [filteredData]);

  return (
    <div className="min-h-screen p-4 md:p-6 space-y-6 max-w-screen-2xl mx-auto bg-[#f6f8ff]/70">
      <div className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-blue-50 border border-blue-100 shadow-sm rounded-xl">
              <img src="/google_ads.webp" alt="Google Ads" className="w-8 h-8 object-contain" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Ad Copy Report — Yenilio</h1>
              <p className="text-sm text-gray-500 mt-0.5">Yenilio — Kampanya bazlı reklam metinleri ve açıklamalar</p>
            </div>
          </div>
          <div className="flex items-center gap-2 text-sm flex-wrap">
            <AccountSwitcher platform="GOOGLE_ADS" />
            <span className="px-3 py-1.5 bg-blue-50 text-blue-700 rounded-lg font-medium">{filteredData.length} Kampanya</span>
            <span className="px-3 py-1.5 bg-indigo-50 text-indigo-700 rounded-lg font-medium">{filteredAds} Reklam</span>
            <span className="px-2.5 py-1.5 bg-emerald-50 text-emerald-700 rounded-lg font-medium flex items-center gap-1">
              <Play className="w-3 h-3" /> {enabledAds}
            </span>
            <span className="px-2.5 py-1.5 bg-orange-50 text-orange-600 rounded-lg font-medium flex items-center gap-1">
              <Pause className="w-3 h-3" /> {pausedAds}
            </span>
          </div>
        </div>
      </div>

      <div className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          placeholder="Headline, açıklama veya kampanya ara..."
          className="w-full pl-11 pr-4 py-3 bg-white border border-gray-200 rounded-2xl text-sm shadow-sm focus:ring-2 focus:ring-blue-100 focus:border-blue-300 outline-none transition-all"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="space-y-4">
        {filteredData.map((c) => (
          <div key={c.campaign} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-5 py-4 border-b border-gray-50 bg-gray-50/50">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <h2 className="font-semibold text-gray-900 text-lg">{c.label}</h2>
                  <span className="text-xs text-gray-400">{c.ads.length} reklam</span>
                </div>
                <span className="text-[10px] font-mono text-gray-400 bg-gray-100 px-2 py-0.5 rounded">{c.campaign}</span>
              </div>
            </div>

            <div className="divide-y divide-gray-50">
              {c.ads.map((ad, adIdx) => {
                const isPaused = ad.status === 'Paused';
                return (
                  <div key={adIdx} className={`p-5 space-y-4 ${isPaused ? 'opacity-60' : ''}`}>
                    <div className="flex items-center justify-between flex-wrap gap-2">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-gray-700">{ad.adGroup}</span>
                        {isPaused ? (
                          <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-orange-50 text-orange-600 border border-orange-200 flex items-center gap-0.5">
                            <Pause className="w-2.5 h-2.5" /> Paused
                          </span>
                        ) : (
                          <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-600 border border-emerald-200 flex items-center gap-0.5">
                            <Play className="w-2.5 h-2.5" /> Enabled
                          </span>
                        )}
                        {ad.path && (
                          <span className="text-xs text-gray-400 bg-gray-50 px-2 py-0.5 rounded">{ad.path}</span>
                        )}
                      </div>
                      <div className="flex items-center gap-2">
                        <span className={`text-[11px] font-semibold px-2.5 py-1 rounded-full border ${STRENGTH[ad.strength] || STRENGTH.Pending}`}>
                          {ad.strength}
                        </span>
                        <a
                          href={ad.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-xs text-blue-500 hover:text-blue-700 flex items-center gap-1 transition-colors max-w-[280px] truncate"
                        >
                          <ExternalLink className="w-3 h-3 flex-shrink-0" />
                          <span className="truncate">{ad.url.replace('https://www.', '')}</span>
                        </a>
                      </div>
                    </div>

                    <div>
                      <div className="flex items-center gap-1.5 mb-2">
                        <Type className="w-3.5 h-3.5 text-indigo-500" />
                        <span className="text-xs font-semibold text-indigo-600 uppercase tracking-wider">Headline'lar</span>
                        <span className="text-[10px] text-gray-400 ml-1">({ad.headlines.length})</span>
                      </div>
                      <div className="flex flex-wrap gap-1.5">
                        {ad.headlines.map((h, i) => {
                          const text = getText(h);
                          const pin = getPin(h);
                          return (
                            <span
                              key={i}
                              className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border bg-indigo-50/70 border-indigo-200/60 text-indigo-800 text-xs font-medium"
                            >
                              <span className="text-[10px] text-indigo-400 font-bold min-w-[14px]">H{i + 1}</span>
                              {text}
                              {pin && (
                                <span className="inline-flex items-center gap-0.5 text-[9px] font-bold text-orange-600 bg-orange-50 border border-orange-200 px-1 py-0.5 rounded ml-0.5">
                                  <Pin className="w-2.5 h-2.5" />{pin}
                                </span>
                              )}
                            </span>
                          );
                        })}
                      </div>
                    </div>

                    <div>
                      <div className="flex items-center gap-1.5 mb-2">
                        <AlignLeft className="w-3.5 h-3.5 text-emerald-500" />
                        <span className="text-xs font-semibold text-emerald-600 uppercase tracking-wider">Açıklamalar</span>
                        <span className="text-[10px] text-gray-400 ml-1">({ad.descriptions.length})</span>
                      </div>
                      <div className="space-y-1.5">
                        {ad.descriptions.map((d, i) => {
                          const text = typeof d === 'string' ? d : d.text;
                          const pin = typeof d === 'object' ? d.pin : null;
                          return (
                            <div
                              key={i}
                              className="flex items-start gap-2 px-3 py-2 rounded-lg border bg-emerald-50/50 border-emerald-200/50 text-sm text-gray-800"
                            >
                              <span className="text-[10px] text-emerald-500 font-bold mt-0.5 min-w-[16px] flex-shrink-0">D{i + 1}</span>
                              <span className="flex-1">{text}</span>
                              {pin && (
                                <span className="inline-flex items-center gap-0.5 text-[9px] font-bold text-orange-600 bg-orange-50 border border-orange-200 px-1 py-0.5 rounded flex-shrink-0">
                                  <Pin className="w-2.5 h-2.5" />{pin}
                                </span>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {filteredData.length === 0 && (
        <div className="bg-white rounded-2xl p-12 text-center shadow-sm border border-gray-100">
          <Search className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <h3 className="text-lg font-medium text-gray-700">Sonuç bulunamadı</h3>
          <p className="text-sm text-gray-500 mt-1">Arama terimini değiştirmeyi dene</p>
        </div>
      )}

      <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-gray-500">
          <span className="font-medium text-gray-600">Reklam Gücü:</span>
          {Object.entries(STRENGTH).map(([key, cls]) => (
            <span key={key} className="flex items-center gap-1.5">
              <span className={`w-3 h-3 rounded border ${cls}`}></span> {key}
            </span>
          ))}
          <span className="mx-1 text-gray-300">|</span>
          <span className="flex items-center gap-1"><Pin className="w-3 h-3 text-orange-500" /> Sabitlenmiş pozisyon</span>
          <span className="mx-1 text-gray-300">|</span>
          <span className="flex items-center gap-1"><Play className="w-3 h-3 text-emerald-500" /> Enabled</span>
          <span className="flex items-center gap-1"><Pause className="w-3 h-3 text-orange-500" /> Paused</span>
        </div>
      </div>
    </div>
  );
}
